import styled from 'styled-components';

export const MycenterWrapper = styled.div `
  //padding-top:4rem;
  width:100%;
  margin:0 auto;
`